"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinAdTag = SpinAdTag;
exports.SpinAiTag = SpinAiTag;
exports.SpinExactMatchTag = SpinExactMatchTag;
exports.SpinPremiumTag = SpinPremiumTag;
exports.SpinRecommendedTag = SpinRecommendedTag;
exports.SpinTrendingTags = SpinTrendingTags;
exports.Tags = Tags;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _classnames = _interopRequireDefault(require("classnames"));
var _information = _interopRequireDefault(require("@ux/icon/information"));
var _utils = require("@site/utils");
var _sharedComponents = require("@site/shared-components");
var _SpinRtb = _interopRequireDefault(require("./SpinRtb"));
function SpinAdTag({
  adTagId = 'promotedTag',
  adTagCssObject = {},
  rtb = '',
  spinsRtbPosition
} = {}) {
  return /*#__PURE__*/_react.default.createElement("span", {
    "data-cy": "ad-slot-label",
    "data-testid": "ad-slot-label",
    className: "spin-is-tagged text-muted ms-2 font-weight-bold"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "ad-slot-label-message",
    "data-cy": "ad-slot-label-message",
    className: "text-uppercase letter-spacing-pt9"
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.Tag, {
    textId: adTagId,
    style: adTagCssObject,
    dataCy: "spin-ad-text",
    className: "mr-0 ms-2"
  }), rtb && spinsRtbPosition === 'tag' && /*#__PURE__*/_react.default.createElement(_SpinRtb.default, {
    rtb: ` | ${rtb}`
  })), rtb && spinsRtbPosition === 'top' && /*#__PURE__*/_react.default.createElement(_SpinRtb.default, {
    rtb: rtb,
    classNames: "font-weight-normal text-black ms-2 ml-2"
  }));
}
SpinAdTag.propTypes = {
  adTagId: _propTypes.default.string,
  adTagCssObject: _propTypes.default.object,
  rtb: _propTypes.default.string,
  spinsRtbPosition: _propTypes.default.oneOf(['tag', 'top', 'bottom'])
};
function SpinExactMatchTag({
  textId = 'twoCards.exact'
}) {
  return /*#__PURE__*/_react.default.createElement(_sharedComponents.Tag, {
    textId: textId,
    dataCy: "exact-match-tag",
    className: "spin-is-tagged exact-match w-fit-content mb-0 ms-2 mr-1",
    color: "bg-warning"
  });
}
SpinExactMatchTag.propTypes = {
  textId: _propTypes.default.string
};
function SpinAiTag({
  textId = 'aiTag'
}) {
  return /*#__PURE__*/_react.default.createElement(_sharedComponents.Tag, {
    textId: textId,
    dataCy: "ai-spin-tag",
    className: "spin-is-tagged ai-spin-tag w-fit-content mb-0 ms-2 mr-1"
  });
}
SpinAiTag.propTypes = {
  textId: _propTypes.default.string
};
function SpinRecommendedTag() {
  return /*#__PURE__*/_react.default.createElement(_sharedComponents.Tag, {
    textId: "dppSolutionsRecommendedAlternate",
    dataCy: "spin-recommended-tag",
    className: "spin-is-tagged recommended w-fit-content ms-2 mr-1",
    color: "bg-warning"
  });
}
function SpinPremiumTag({
  isAuction,
  isAftermarketPremium,
  isMobile,
  tagsAndInfo = {},
  market = 'en-US',
  premiumTagStyle = {},
  showBadge
}) {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const {
    auctionPhone,
    premiumPhone
  } = tagsAndInfo;
  const supportPhone = isAuction ? auctionPhone : premiumPhone;
  const tooltipIconColor = 'gray';
  const tooltipMessage = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "premiumTooltipLine1"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "premiumTooltipLine2"
  })), !_utils.MarketHelper.isPhoneHiddenMarket(market) && supportPhone && /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "premiumTooltipLine3",
    values: {
      phone: supportPhone
    }
  })));
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('d-flex spin-is-tagged flex-wrap align-items-center', {
      'ms-2': isMobile,
      'ms-1': !isMobile
    })
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.Tag, {
    textId: "premiumTag",
    className: (0, _classnames.default)('text-uppercase font-weight-bold letter-spacing-pt9 mr-0', {
      'text-purple': !premiumTagStyle.css?.color,
      'ms-2': isMobile,
      'ms-1': !isMobile,
      'text-black spin-tag-bg-purple p-1 ms-1': showBadge
    }),
    dataCy: "spin-premium-tag",
    icon: premiumTagStyle?.custom?.icon || null,
    style: premiumTagStyle.css || null
  }), !_utils.MarketHelper.isPhoneHiddenMarket(market) && supportPhone && isAftermarketPremium && /*#__PURE__*/_react.default.createElement("span", {
    className: "text-muted ms-1 ml-2",
    "data-cy": "spin-support-phone",
    "data-testid": "spin-support-phone"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "phoneForHelp",
    values: {
      phone: supportPhone
    }
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "align-items-center px-1",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.TooltipWrapper, {
    tooltipButtonText: /*#__PURE__*/_react.default.createElement(_information.default, {
      name: "information",
      color: tooltipIconColor,
      width: "0.75rem",
      height: "0.75rem"
    }),
    title: /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "premiumTooltipTitle"
    }),
    tooltipContent: tooltipMessage,
    id: formatMessage({
      id: 'premiumTooltipTitle'
    })
  })));
}
SpinPremiumTag.propTypes = {
  isAuction: _propTypes.default.bool,
  isAftermarketPremium: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  tagsAndInfo: _propTypes.default.object,
  market: _propTypes.default.string,
  premiumTagStyle: _propTypes.default.object,
  showBadge: _propTypes.default.bool
};
function SpinTrendingTags({
  tags
}) {
  return /*#__PURE__*/_react.default.createElement(_sharedComponents.TrendingTags, {
    tags: tags,
    dataCyWrapper: "spin-trending-tag",
    dataCyTag: "spin-trending-tag-text",
    classNameWrapper: "spin-is-tagged text-muted ms-2 mb-1 mr-1 d-flex w-100",
    classNameTag: "trending ms-2 mr-1"
  });
}
SpinTrendingTags.propTypes = {
  tags: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    textValues: _propTypes.default.object,
    color: _propTypes.default.string
  }))
};
function Tags({
  domainExtension,
  isPremium,
  isRecommended,
  isAd,
  isExactMatch,
  isAuction,
  isAftermarketPremium,
  inventory,
  isMobile,
  tagsAndInfo,
  market,
  premiumTagStyle
}) {
  const {
    trendingTags,
    shouldVerticalStack,
    showTagsSeparator,
    showPremiumTagBadge
  } = tagsAndInfo;
  const isTrendingTagsVisible = trendingTags?.[domainExtension] && !isPremium;
  const SpinPremiumTagComponent = () => /*#__PURE__*/_react.default.createElement(SpinPremiumTag, {
    isAuction,
    isAftermarketPremium,
    isMobile,
    tagsAndInfo,
    market,
    premiumTagStyle,
    showBadge: showPremiumTagBadge
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isTrendingTagsVisible ? /*#__PURE__*/_react.default.createElement(SpinTrendingTags, {
    tags: trendingTags[domainExtension]
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isRecommended && /*#__PURE__*/_react.default.createElement(SpinRecommendedTag, null), isAd && shouldVerticalStack && /*#__PURE__*/_react.default.createElement(SpinAdTag, tagsAndInfo), isExactMatch && /*#__PURE__*/_react.default.createElement(SpinExactMatchTag, {
    textId: tagsAndInfo?.exactTagTextId
  })), tagsAndInfo?.showAiTag && inventory === 'gpt' && /*#__PURE__*/_react.default.createElement(SpinAiTag, {
    textId: tagsAndInfo?.aiTagTextId
  }), !shouldVerticalStack && /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-items-center"
  }, isAd && /*#__PURE__*/_react.default.createElement("span", {
    className: "mr-2 d-flex flex-wrap align-items-center",
    "data-cy": "spin-horizontal-ad-tag",
    "data-testid": "spin-horizontal-ad-tag"
  }, /*#__PURE__*/_react.default.createElement(SpinAdTag, tagsAndInfo)), isAd && showTagsSeparator && isPremium && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "spin-tag-separator",
    "data-testid": "spin-tag-separator",
    className: "d-flex justify-items-center text-muted"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "spin-tag-separator mr-2 text-muted"
  })), isPremium && /*#__PURE__*/_react.default.createElement(SpinPremiumTagComponent, null)), isPremium && shouldVerticalStack && /*#__PURE__*/_react.default.createElement(SpinPremiumTagComponent, null));
}
Tags.propTypes = {
  inventory: _propTypes.default.string,
  domainExtension: _propTypes.default.string,
  isPremium: _propTypes.default.bool,
  isRecommended: _propTypes.default.bool,
  isAd: _propTypes.default.bool,
  isExactMatch: _propTypes.default.bool,
  isAuction: _propTypes.default.bool,
  isAftermarketPremium: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  tagsAndInfo: _propTypes.default.object,
  market: _propTypes.default.string,
  premiumTagStyle: _propTypes.default.object
};